import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Customer, LoyaltyRewardTier } from 'src/app/core/models/customer.model';
import { Merchant } from 'src/app/core/models/restaurant.model';
import { UtilService } from 'src/app/core/services/util.service';
import { MerchantStore } from 'src/app/core/stores/merchant.store';
import { PaymentStore } from 'src/app/core/stores/payment.store';
import { InfoMessage } from '../../../../core/enums/message.enum';
import { RouteService } from '../../../../core/services/route.service';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss'],
})
export class RewardsComponent implements OnInit, OnDestroy {
  public merchant = new Merchant();
  private destroyed$ = new Subject<void>();
  public loyaltyRewards: LoyaltyRewardTier[];
  public forceTouched = false;
  public hasLoyaltyData = false;
  public title: string = InfoMessage.enter_phone_for_loyalty;
  public verificationCustomer = false;
  public customer: Customer = new Customer();
  public isVerifyCustomer: boolean;

  constructor(
    private merchantStore: MerchantStore,
    private titleService: Title,
    public paymentStore: PaymentStore,
    private utilService: UtilService,
    private routeService: RouteService,
  ) {
    this.paymentStore.customer$.subscribe((customer: Customer) => {
      this.customer = customer;
    });
    this.paymentStore.verificationCustomer$.subscribe(isVerify => {
      this.isVerifyCustomer = isVerify;
    });
  }

  ngOnInit() {
    this.merchantStore.getLoyaltyProgram(this.routeService.getMerchantId());
    this.initComponent();
  }

  async initComponent(): Promise<void> {
    await this.utilService.activeLoader(InfoMessage.loading_rewards);
    this.merchantStore.merchantData$.pipe(filter(Boolean)).subscribe((merchant: Merchant) => {
      this.merchant = merchant;
      if (this.merchant.merchantName) {
        this.titleService.setTitle(this.merchant.merchantName);
      }
    });
    this.merchantStore.loyaltyProgram$.subscribe((loyaltyProgram: any) => {
      if (loyaltyProgram) {
        this.loyaltyRewards = loyaltyProgram;
        this.hasLoyaltyData = true;
      } else {
        this.hasLoyaltyData = false;
      }
      this.utilService.dismissActiveLoader();
    });
  }

  public customerVerification(): void {
    this.verificationCustomer = true;
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
